import React, {FC, useState} from 'react';
import { DirectoryBar } from '../components/DirectoryBar';
import { H1 } from '../components/H1';
import { H5 } from '../components/H5';
import {SearchField} from "../components/SearchField";
import {useHistory} from "react-router-dom";
import {ReactComponent as SearchIcon} from "../assets/svg/icon-search.svg";
import {Icon} from "../components/Icon";

export const Certification = () => {
    const history = useHistory();
    const [searchText, setSearchText] = useState<string>('');
    const [searchToggle, setSearchToggle] = useState(false);
    const onSearchProduct = () => {
        history.push(`/results/${encodeURIComponent(searchText)}`, {keyword: searchText});
        setSearchText('');
        setSearchToggle(false);
    };
  return (
    <>
      <DirectoryBar text="홈, 일반적합인증" />
        <SearchField
            placeholder="검색하기"
            autoFocus={true}
            onChange={e => setSearchText(e.target.value)}
            onSearch={onSearchProduct}
            className="m-auto mb-5 mt-20"
        />
      <div className="max-w-2xl m-auto text-center pb-20">
          <h2>GCC - 미국 컴플라이언스 인증서</h2><br/>

          <h4 className="font-semibold text-15">칼하트 워크 인 프로그레스의 CPSIA 규정 준수 인증서 데이터베이스에 오신 것을 환영합니다.</h4>
          <br/>
          <div className="text-left">
          미국 규정 준수 인증서를 찾는 방법:<br/><br/>
              <span className="text-2xl text-gray-500">&#8226;</span> 이 웹사이트에서 찾기 - 소비자 제품 안전 개선법, 섹션 102(a) 및 16 CFR Part 1110에서 요구하는 사회 보장 및 세금 문제와 관련한 사항은 담당 직원의 지원 및 칼하트 구매 주문 번호 (9자리 숫자/알파)를 입력하는 것을 통해 제품에 대한 CPSIA 일반 적합성 인증서 (GCC)에 엑세스 할 수 있습니다.<br/><br/>
              <span className="text-2xl text-gray-500">&#8226;</span>	검색방법 - 9자리 P.O.를 입력하세요. “13PO01810” 형식으로 페이지 중앙 상단의 검색 상자에 번호를 입력하면 됩니다.
          <br/><br/>
          P.O를 찾을 수 있는 곳 숫자:<br/><br/>
              <span className="text-2xl text-gray-500">&#8226;</span>	칼하트 제품 라벨 - 이 번호는 케어 라벨 태그 상단에서 찾을 수 있습니다. 아래 예를 참조하십시오<br/><br/>

              <img className="m-auto" src={"https://s3.ap-northeast-2.amazonaws.com/carhartt-wip.entropyparadox.link/static/media/po_number.png"} alt="" />
          제품에 대한 모든 인증서는 이 사이트에서 제공하지만 검색이 안될 경우 칼하트 공급업체 규정 준수 부서에 문의해주세요.(Email: gcc@carhartt-wip.com).<br/>
          법률 및 작업장의 규정 준수 – 칼하트가 공급업체 및 승인된 하청업체는 노동, 사회 보험/보안, 근로자의 건강 및 안전, 환경과 관련된 곳을 포함하여 비즈니스를 수행하는 모든 지역의 법률 및 규정을 준수합니다.<br/>또한 공급업체와 승인된 하청업체는 칼하트 사업을 영위하는 국가에서 적용하는 법률을 준수하기 위해 칼하트와 전적으로 협력해야 합니다.<br/>
<br/><hr/><br/>
          행동 강령 (Code of Conduct)에 명시된 바와 같이 칼하트윕은 기업 가치를 공유하고 사회 및 환경 관행의 지속적인 개선에 전념하는 회사와 파트너가 되기를 열망합니다.<br/>이 Workplace Important에 요약된 표준이 칼하트윕 제품의 개발, 제조 및 운송에 관련된 공급업체의 글로벌 네트워크 전체에 적용되는 것이 우리의 의도입니다.<br/>칼하트윕이 직접적인 계약 관계를 맺고 있는 공급업체는 이러한 표준을 모든 하위 공급업체로 확장하고 칼하트윕을 지원하는 글로벌 공급 네트워크 전반에 걸쳐 정렬된 표준이 채택되도록 하는 관행을 시작해야 합니다.
          </div>
      </div>
    </>
  );
};

